import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GoogleTag = () => {
  const location = useLocation();

  // Load script once
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-7B1LWTKRE1";
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag(){window.dataLayer.push(arguments);}
    window.gtag = gtag;

    window.gtag("js", new Date());
    window.gtag("config", "G-7B1LWTKRE1");
  }, []);

  // Track page changes
  useEffect(() => {
    if (window.gtag) {
      window.gtag("config", "G-7B1LWTKRE1", {
        page_path: location.pathname,
        page_title: document.title,
      });
    }
  }, [location]);

  return null;
};

export default GoogleTag;